var ActivityConst = {
    ActivitySignType: {
        arena_champion: 1              // 冠军赛
        ,arena_champion_guess: 2       // 冠军赛竞猜
        ,godbattle_sign: 3             // 众神战场报名
        ,godbattle: 4                  // 众神战场
    },

    //  限时活动里面的单个活动id
    limit_index: {
        escort: 1, //护送
        union : 2, //公会
        fightFirst: 3, //首席争霸
        allGod: 4,//众神战场
        guildwar: 5, // 公会战
        champion: 6, // 冠军赛
        ladder: 7    // 天梯争霸
    }
}

module.exports = ActivityConst